// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CollapsedCaseListItem_wrapper__3kJbZ","assignedUser":"CollapsedCaseListItem_assignedUser__1liy6","date":"CollapsedCaseListItem_date__1p0rO"};